// config.js

const bizIcon = "https://mybizsolutions.us/static/media/icon-app-logo.83ff8bf39a11df9fb7ac.jpg";
const imageOne = "https://irp.cdn-website.com/999acf5a/dms3rep/multi/shutterstock_1750902653.jpg";
const imageTwo = "https://irp.cdn-website.com/999acf5a/dms3rep/multi/unnamed+%281%29.jpg";
const imageThree = "https://irp.cdn-website.com/999acf5a/dms3rep/multi/shutterstock_2133378409.jpg";
const imageFour = "https://irp.cdn-website.com/999acf5a/dms3rep/multi/shutterstock_2352867379.jpg";
const imageFive = "https://lirp.cdn-website.com/999acf5a/dms3rep/multi/opt/unnamed+%286%29-600w.jpg";

const socialMediaLink = 'https://www.thackerspainting.com/';

export const siteConfig = {
  title: "Thacker's Painting Inc.",
  metaDescription: "Thacker's Painting Inc.",
  theme: {
    primaryColor: "blue-500",
    secondaryColor: "gray-200",
    accentColor: "text-blue-500"
  },
  logo: {
    src: bizIcon,
    alt: "Thacker's Painting Inc.",
  },
  navigation: [
    { name: "Services", sectionId: "services" },
    { name: "About", sectionId: "about" },
    { name: "Location", sectionId: "location" },
  ],
  businessDetails: {
    name: "Thacker's Painting Inc.",
    headline: "Transforming Spaces with Color and Precision",
    address: "Palmyra, Virginia, United States",
    description: 
      "Thacker's Painting Inc. delivers high-quality painting services to transform your spaces. From interiors to exteriors, we bring vibrant color and precision to homes and businesses across Palmyra and beyond.",
  },
  images: {
    business: {
      src: imageOne,
      alt: "Thacker's Painting Services",
      width: 2432,
      height: 1442
    }
  },
  features: [
    {
      description:
        "Expert craftsmanship is at the heart of Thacker's Painting Inc., where every project is handled with precision and care to exceed your expectations.",
    },
    {
      description:
        "We prioritize customer satisfaction by providing free estimates, transparent pricing, and tailored painting solutions to suit your unique needs.",
    },
    {
      description:
        "Using premium materials and versatile techniques, our family-dedicated team delivers reliable, high-quality results for homes and businesses alike.",
    },
  ],
  services: {
    sectionTitle: "Our Services",
    description: 
      "At Thacker's Painting Inc., we bring over 30 years of experience and a passion for craftsmanship to every project. As a family-owned business, we treat your home as if it were our own, delivering top-notch interior and exterior painting services with exceptional attention to detail. From transforming walls with vibrant colors to restoring cabinets and staining decks, we use premium materials and proven techniques to ensure long-lasting, beautiful results. Our transparent pricing and personalized solutions make Thacker's Painting Inc. your trusted partner for all your painting needs.",
    callouts: [
      {
        name: 'Interior & Exterior Painting',
        description: 
          "Revitalize your home with professional painting services that bring fresh color and life to your walls, inside and out.",
        imageSrc: imageTwo,
        imageAlt: 'A beautifully painted house exterior with a vibrant and clean look',
      },
      {
        name: 'Cabinet Painting & Refinishing',
        description: 
          "Restore and refresh your cabinets with expert painting and refinishing for a polished, modern look.",
        imageSrc: imageThree,
        imageAlt: 'Finished kitchen cabinets with a smooth and refined paint job',
      },
      {
        name: 'Deck Staining',
        description: 
          "Protect and enhance your outdoor spaces with professional deck staining that adds beauty and durability.",
        imageSrc: imageFour,
        imageAlt: 'A wooden deck with a rich and professional stain finish',
      }
    ],
    otherServices: [
      "Wallpaper and Popcorn Ceiling Removal",
      "Drywall and Plaster Repair",
      "Epoxy Flooring and Garage Floor Coating",
    ]
  },  
  about: {
    sectionTitle: "About Us",
    description: 
      "At Thacker's Painting Inc., we're more than just painters – we're artisans with over 30 years of experience transforming homes and businesses. As a family-owned business, we treat every project as if it were our own, delivering exceptional attention to detail and high-quality craftsmanship. From vibrant interiors to durable exteriors, we use premium materials to ensure stunning, long-lasting results. With affordable and transparent estimates, we bring professionalism, reliability, and a personal touch to every job we undertake.",
    image: {
      src: imageFive,
      alt: "Thacker's Painting team delivering exceptional painting services",
      width: 2432,
      height: 1442
    }
  },
  location: {
    sectionTitle: "Our Location",
    destinationAddress: "Palmyra, Virginia, United States",
    googleMapsEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3090.005671234798!2d-78.27445108476382!3d37.85730597971998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89b1db4c7f5f1f17%3A0xabcdef1234567890!2sPalmyra%2C%20VA%2022963%2C%20USA!5e0!3m2!1sen!2sus!4v1710412345678!5m2!1sen!2sus",
    subCategories: [
      { 
        name: 'Apple Maps', 
        url: 'https://maps.apple.com/?address=Palmyra,%20VA,%20United%20States&ll=37.857306,-78.274451&q=Palmyra,%20VA'
      },
      { 
        name: 'Bing Maps', 
        url: 'https://www.bing.com/maps?q=Palmyra,+VA,+United+States&FORM=HDRSC6'
      },
      { 
        name: 'Google Earth', 
        url: 'https://earth.google.com/web/search/Palmyra,+VA,+United+States/@37.857306,-78.274451,15a,814.57589625d,35y,0h,0t,0r'
      },
      { 
        name: 'Google Maps', 
        url: 'https://www.google.com/maps/place/Palmyra,+VA,+United+States/@37.857306,-78.274451,15z'
      }
    ]
  },  
  contact: {
    sectionTitle: "Ready to transform your space?",
    description: "Contact us for a free estimate and let us bring your vision to life!",
    socialLinks: {
      facebook: socialMediaLink,
      instagram: socialMediaLink,
      twitter: socialMediaLink,
      youtube: socialMediaLink,
      tiktok: socialMediaLink
    },
    contactNumbers: ["434-989-1237"],
    logo: bizIcon,
    emailRecipient: "thackerspaintinginc@gmail.com"
  },
  footer: {
    bizSolutionsLogo: "https://mybizsolutions.us/static/media/icon-app-logo.83ff8bf39a11df9fb7ac.jpg"
  }
};
